export const sortAlphabeticalAsc = (a: string, b: string): number => b.localeCompare(a);

export const sortAlphabeticalDesc = (a: string, b: string): number => a.localeCompare(b);

export const sortNumericDesc = (a: number, b: number): number => b - a;

export const sortDateDesc = (a: Date, b: Date): number => sortNumericDesc(a.getTime(), b.getTime());

export const sortBooleanTrueFirst = (a: boolean, b: boolean): number => {
	if (a === b) {
		return 0;
	}
	return a ? -1 : 1;
};
